import FormComponent from "./Components/FormComponent";
import FormInputs from "./Components/FormInputs";
import React from "react";

export default class FormMessage extends FormComponent {
    constructor(props) {
        super(props);
    }

    generateDescriptionBlock() {
        if (this.props.payload.describtion && this.props.payload.describtion.trim() !== '') {
            return <div className='user-live-chat__describtion'>
                        {this.props.payload.describtion}
                    </div>
        }
        else if (this.props.description && this.props.payload.description.trim() !== '') {
            return <div className='user-live-chat__description'>
                        {this.props.payload.description}
                    </div>
        }
        else {
            return;
        }
    }

    render() {
        return (
            <div className={this.generateSenderClassName('form')}>
                {this.generateSenderMessage()}
                <div className='form__text message-text'>
                    <div className='form__heading'>
                        {this.props.payload.heading}
                    </div>
                    {this.generateDescriptionBlock()}
                    <form className='advanced-form__form form' onSubmit={this.submitForm}>
                        {this.props.payload.formFields.map((input) => {
                            return FormInputs.mapFormInput(input, this.formId)
                        })}
                    </form>
                </div>
            </div>
        );
    }
}